import api from "../services/api";

/**
 * Device is identified up front so the backend can pick the right Exotel flow:
 * mobile dials the ExoPhone directly (Connect Applet / Passthru), desktop can't
 * open a dialer so Exotel calls the customer's own phone first (click-to-call).
 */
export function isMobileDevice() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || navigator.vendor || "";
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return true;
  return Boolean(navigator.maxTouchPoints > 0 && window.matchMedia?.("(max-width: 900px)")?.matches);
}

/**
 * Start a masked Exotel PSTN call (same as Messenger → Call).
 * Pass caregiverId from marketplace/profile, or calleeUserId from Messenger/dashboard.
 */
export async function startExotelPhoneCall({ calleeUserId, caregiverId, marketplace = false } = {}) {
  const payload = { callType: "audio", deviceType: isMobileDevice() ? "mobile" : "desktop" };
  const uid = Number(calleeUserId);
  const cid = Number(caregiverId);
  if (Number.isFinite(uid) && uid > 0) payload.calleeUserId = uid;
  if (Number.isFinite(cid) && cid > 0) payload.caregiverId = cid;
  if (marketplace) payload.source = "marketplace";
  if (!payload.calleeUserId && !payload.caregiverId) {
    const err = new Error("This person cannot be called yet.");
    err.statusCode = 400;
    throw err;
  }
  const res = await api.startMessengerCall(payload);
  const rawMode = String(res?.mode || "").toLowerCase();
  const mode = rawMode === "webrtc" ? "webrtc" : rawMode === "click2call" ? "click2call" : "tel";
  return {
    message:
      res?.message ||
      (mode === "webrtc"
        ? "Stay on this screen. Numbers stay private."
        : mode === "click2call"
          ? "We're calling your phone now. Please answer to connect — both numbers stay private."
          : "We opened your dialer with a private number. Press the green call button to connect. Both numbers stay private."),
    session: res?.session || res?.data?.session || null,
    provider: res?.provider || "exotel",
    mode,
    exoPhone: res?.exoPhone || res?.data?.exoPhone || "",
    accessToken: res?.accessToken || res?.data?.accessToken || "",
    appUserId: res?.appUserId || res?.data?.appUserId || "",
    numbersMasked: res?.numbersMasked !== false,
  };
}
